import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {observer} from 'mobx-react';
import ReactJson from 'react-json-view'
import Divider from '@material-ui/core/Divider';

@observer
export class ConfigsJsonViewerComponent extends LauncherComponentBase<{}> {

    render() {
        return (
            <div style={{margin:'10px'}}>
                <h1>JSON view</h1>
                <Divider/>
                <div style={{marginTop:'10px'}}>
                    <ReactJson src={this.services.configsStorage.jsonView} name={false} displayDataTypes={false} displayObjectSize={false}/>
                </div>
            </div>
        )
    }
}



